/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createScenarioRequestSchema = z.object({
  description: z.string().min(0).max(500).nullish(),
  name: z.string().min(0).max(255),
});
